/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GamificationType } from './GamificationType';
import {
    GamificationTypeFromJSON,
    GamificationTypeFromJSONTyped,
    GamificationTypeToJSON,
    GamificationTypeToJSONTyped,
} from './GamificationType';
import type { GamificationParticipationResponse } from './GamificationParticipationResponse';
import {
    GamificationParticipationResponseFromJSON,
    GamificationParticipationResponseFromJSONTyped,
    GamificationParticipationResponseToJSON,
    GamificationParticipationResponseToJSONTyped,
} from './GamificationParticipationResponse';
import type { GamificationStatus } from './GamificationStatus';
import {
    GamificationStatusFromJSON,
    GamificationStatusFromJSONTyped,
    GamificationStatusToJSON,
    GamificationStatusToJSONTyped,
} from './GamificationStatus';
import type { GamificationEligibility } from './GamificationEligibility';
import {
    GamificationEligibilityFromJSON,
    GamificationEligibilityFromJSONTyped,
    GamificationEligibilityToJSON,
    GamificationEligibilityToJSONTyped,
} from './GamificationEligibility';
import type { GamificationMilestone } from './GamificationMilestone';
import {
    GamificationMilestoneFromJSON,
    GamificationMilestoneFromJSONTyped,
    GamificationMilestoneToJSON,
    GamificationMilestoneToJSONTyped,
} from './GamificationMilestone';
import type { GamificationShareTemplate } from './GamificationShareTemplate';
import {
    GamificationShareTemplateFromJSON,
    GamificationShareTemplateFromJSONTyped,
    GamificationShareTemplateToJSON,
    GamificationShareTemplateToJSONTyped,
} from './GamificationShareTemplate';
import type { GamificationOutputConnection } from './GamificationOutputConnection';
import {
    GamificationOutputConnectionFromJSON,
    GamificationOutputConnectionFromJSONTyped,
    GamificationOutputConnectionToJSON,
    GamificationOutputConnectionToJSONTyped,
} from './GamificationOutputConnection';

/**
 * 
 * @export
 * @interface GamificationModelResponse
 */
export interface GamificationModelResponse {
    /**
     * 
     * @type {string}
     * @memberof GamificationModelResponse
     */
    id: string;
    /**
     * 
     * @type {GamificationType}
     * @memberof GamificationModelResponse
     */
    type: GamificationType;
    /**
     * 
     * @type {string}
     * @memberof GamificationModelResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GamificationModelResponse
     */
    description?: string;
    /**
     * Type-specific rules — shape determined by type field
     * @type {{ [key: string]: any; }}
     * @memberof GamificationModelResponse
     */
    config: { [key: string]: any; };
    /**
     * Type-specific runtime data — shape determined by type field
     * @type {{ [key: string]: any; }}
     * @memberof GamificationModelResponse
     */
    state: { [key: string]: any; };
    /**
     * 
     * @type {GamificationStatus}
     * @memberof GamificationModelResponse
     */
    status: GamificationStatus;
    /**
     * 
     * @type {number}
     * @memberof GamificationModelResponse
     */
    startAt?: number;
    /**
     * 
     * @type {number}
     * @memberof GamificationModelResponse
     */
    endAt?: number;
    /**
     * 
     * @type {string}
     * @memberof GamificationModelResponse
     */
    brandActivationId?: string;
    /**
     * A DEFINITION in the gamification catalog — never live, never accepts plays. Instances are created from it per host (Definition/Assignment split, 2026-08-31).
     * @type {boolean}
     * @memberof GamificationModelResponse
     */
    isTemplate?: boolean;
    /**
     * The definition this instance was created from. Template edits propagate to non-overridden fields.
     * @type {string}
     * @memberof GamificationModelResponse
     */
    templateId?: string;
    /**
     * Fields this instance owns locally — template propagation skips them. Stamped when the instance is edited directly.
     * @type {Array<string>}
     * @memberof GamificationModelResponse
     */
    overriddenFields?: Array<string>;
    /**
     * 
     * @type {Array<GamificationMilestone>}
     * @memberof GamificationModelResponse
     */
    milestones: Array<GamificationMilestone>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GamificationModelResponse
     */
    completionRewardConfigIds: Array<string>;
    /**
     * Paid ONCE on first participation (e.g. a prediction pick). Empty = no participation reward.
     * @type {Array<string>}
     * @memberof GamificationModelResponse
     */
    participationRewardConfigIds?: Array<string>;
    /**
     * 
     * @type {GamificationEligibility}
     * @memberof GamificationModelResponse
     */
    eligibility: GamificationEligibility;
    /**
     * 
     * @type {Array<GamificationOutputConnection>}
     * @memberof GamificationModelResponse
     */
    outputConnections: Array<GamificationOutputConnection>;
    /**
     * 
     * @type {GamificationShareTemplate}
     * @memberof GamificationModelResponse
     */
    shareTemplate?: GamificationShareTemplate;
    /**
     * 
     * @type {string}
     * @memberof GamificationModelResponse
     */
    gameId?: string;
    /**
     * 
     * @type {string}
     * @memberof GamificationModelResponse
     */
    scoringTemplateId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GamificationModelResponse
     */
    objectiveTemplateIds: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof GamificationModelResponse
     */
    participantCount: number;
    /**
     * 
     * @type {number}
     * @memberof GamificationModelResponse
     */
    completionCount: number;
    /**
     * 
     * @type {GamificationParticipationResponse}
     * @memberof GamificationModelResponse
     */
    participation?: GamificationParticipationResponse;
    /**
     * 
     * @type {string}
     * @memberof GamificationModelResponse
     */
    createdBy: string;
    /**
     * 
     * @type {number}
     * @memberof GamificationModelResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof GamificationModelResponse
     */
    updatedAt: number;
}



/**
 * Check if a given object implements the GamificationModelResponse interface.
 */
export function instanceOfGamificationModelResponse(value: object): value is GamificationModelResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('milestones' in value) || value['milestones'] === undefined) return false;
    if (!('completionRewardConfigIds' in value) || value['completionRewardConfigIds'] === undefined) return false;
    if (!('eligibility' in value) || value['eligibility'] === undefined) return false;
    if (!('outputConnections' in value) || value['outputConnections'] === undefined) return false;
    if (!('objectiveTemplateIds' in value) || value['objectiveTemplateIds'] === undefined) return false;
    if (!('participantCount' in value) || value['participantCount'] === undefined) return false;
    if (!('completionCount' in value) || value['completionCount'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GamificationModelResponseFromJSON(json: any): GamificationModelResponse {
    return GamificationModelResponseFromJSONTyped(json, false);
}

export function GamificationModelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamificationModelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': GamificationTypeFromJSON(json['type']),
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'config': json['config'],
        'state': json['state'],
        'status': GamificationStatusFromJSON(json['status']),
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'brandActivationId': json['brandActivationId'] == null ? undefined : json['brandActivationId'],
        'isTemplate': json['isTemplate'] == null ? undefined : json['isTemplate'],
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'overriddenFields': json['overriddenFields'] == null ? undefined : json['overriddenFields'],
        'milestones': ((json['milestones'] as Array<any>).map(GamificationMilestoneFromJSON)),
        'completionRewardConfigIds': json['completionRewardConfigIds'],
        'participationRewardConfigIds': json['participationRewardConfigIds'] == null ? undefined : json['participationRewardConfigIds'],
        'eligibility': GamificationEligibilityFromJSON(json['eligibility']),
        'outputConnections': ((json['outputConnections'] as Array<any>).map(GamificationOutputConnectionFromJSON)),
        'shareTemplate': json['shareTemplate'] == null ? undefined : GamificationShareTemplateFromJSON(json['shareTemplate']),
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'scoringTemplateId': json['scoringTemplateId'] == null ? undefined : json['scoringTemplateId'],
        'objectiveTemplateIds': json['objectiveTemplateIds'],
        'participantCount': json['participantCount'],
        'completionCount': json['completionCount'],
        'participation': json['participation'] == null ? undefined : GamificationParticipationResponseFromJSON(json['participation']),
        'createdBy': json['createdBy'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function GamificationModelResponseToJSON(json: any): GamificationModelResponse {
    return GamificationModelResponseToJSONTyped(json, false);
}

export function GamificationModelResponseToJSONTyped(value?: GamificationModelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': GamificationTypeToJSON(value['type']),
        'name': value['name'],
        'description': value['description'],
        'config': value['config'],
        'state': value['state'],
        'status': GamificationStatusToJSON(value['status']),
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'brandActivationId': value['brandActivationId'],
        'isTemplate': value['isTemplate'],
        'templateId': value['templateId'],
        'overriddenFields': value['overriddenFields'],
        'milestones': ((value['milestones'] as Array<any>).map(GamificationMilestoneToJSON)),
        'completionRewardConfigIds': value['completionRewardConfigIds'],
        'participationRewardConfigIds': value['participationRewardConfigIds'],
        'eligibility': GamificationEligibilityToJSON(value['eligibility']),
        'outputConnections': ((value['outputConnections'] as Array<any>).map(GamificationOutputConnectionToJSON)),
        'shareTemplate': GamificationShareTemplateToJSON(value['shareTemplate']),
        'gameId': value['gameId'],
        'scoringTemplateId': value['scoringTemplateId'],
        'objectiveTemplateIds': value['objectiveTemplateIds'],
        'participantCount': value['participantCount'],
        'completionCount': value['completionCount'],
        'participation': GamificationParticipationResponseToJSON(value['participation']),
        'createdBy': value['createdBy'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

